import { Link } from 'react-router-dom';
import { FaLinkedin, FaTwitter, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { LogoLight } from './Logo';

export default function Footer() {
  return (
    <footer className="bg-[#0c1b4d] text-gray-300">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">

          {/* Brand */}
          <div>
            <div className="mb-3">
              <LogoLight size={52} showSubtitle={true} />
            </div>
            <p className="text-sm text-gray-400 mb-4 leading-relaxed">
              Empowering organizations through strategic IT consulting and cutting-edge technology solutions.
            </p>
            <div className="flex gap-3">
              <a href="#top" className="w-8 h-8 bg-white bg-opacity-10 rounded-lg flex items-center justify-center text-gray-400 hover:text-cyan-400 hover:bg-opacity-20 transition-all">
                <FaLinkedin size={15} />
              </a>
              <a href="#top" className="w-8 h-8 bg-white bg-opacity-10 rounded-lg flex items-center justify-center text-gray-400 hover:text-cyan-400 hover:bg-opacity-20 transition-all">
                <FaTwitter size={15} />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wide">Services</h3>
            <ul className="space-y-2 text-sm">
              {['IT Consulting', 'Cloud Solutions', 'Software Development', 'Managed Services', 'Data & Analytics', 'Cybersecurity'].map(s => (
                <li key={s}>
                  <Link to="/services" className="text-gray-400 hover:text-cyan-400 transition-colors">{s}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wide">Company</h3>
            <ul className="space-y-2 text-sm">
              {[
                { label: 'About Us', to: '/about' },
                { label: 'Services', to: '/services' },
                { label: 'Careers', to: '/careers' },
                { label: 'Insights', to: '/insights' },
                { label: 'Contact', to: '/contact' },
              ].map(item => (
                <li key={item.label}>
                  <Link to={item.to} className="text-gray-400 hover:text-cyan-400 transition-colors">{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wide">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2.5">
                <FaMapMarkerAlt className="text-cyan-400 mt-0.5 flex-shrink-0" size={13} />
                <span className="text-gray-400">Boston, MA 02101</span>
              </li>
              <li className="flex items-center gap-2.5">
                <FaPhone className="text-cyan-400 flex-shrink-0" size={13} />
                <span className="text-gray-400">617-860-7304</span>
              </li>
              <li className="flex items-center gap-2.5">
                <FaEnvelope className="text-cyan-400 flex-shrink-0" size={13} />
                <a href="mailto:hr@marvyitservices.com" className="text-gray-400 hover:text-cyan-400 transition-colors">
                  hr@marvyitservices.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white border-opacity-10 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500">
          <p>© {new Date().getFullYear()} MARVY IT Services, Inc. All rights reserved.</p>
          <div className="flex gap-4 mt-3 md:mt-0">
            <a href="#top" className="hover:text-gray-300 transition-colors">Privacy Policy</a>
            <a href="#top" className="hover:text-gray-300 transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
